import { Button, ButtonColors, ButtonVariants } from "@inno-ui/button";
import { Dialog } from "@inno-ui/dialog";
import { MultiplyIcon, PlusIcon } from "@inno-ui/icons";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useAppForm } from "../../../../../hooks/use-form";
import { useAppointmentStore } from "../../../../../store/appointment/appointment-store";
import { AddGuestForm } from "./add-guest-form/add-guest-form";
import { ADD_GUEST_FORM_FIELDS } from "./add-guest-form/add-guest-form.constant";
import { addGuestFormSchema } from "./add-guest-form/add-guest-form.schema";

export function AddGuest() {
  const { addParticipant } = useAppointmentStore();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const { t } = useTranslation();

  const form = useAppForm({
    defaultValues: ADD_GUEST_FORM_FIELDS,
    onSubmit: ({ value }) => {
      addParticipant({
        id: Math.random().toString(),
        firstName: value.firstName,
        lastName: value.lastName,
        email: value.email,
        phone: value.phone,
        gender: value.gender.value,
      });
      form.reset();
      setIsDialogOpen(false);
    },
    validators: {
      onSubmit: addGuestFormSchema,
    },
  });

  return (
    <>
      <Dialog
        isOpen={isDialogOpen}
        closeOnClickOutside={false}
        title={t("add-guest")}
        // @ts-expect-error
        body={<AddGuestForm form={form} />}
        actions={[
          {
            label: t("cancel"),
            icon: MultiplyIcon,
            onClick: () => setIsDialogOpen(false),
          },
          {
            label: t("add-guest"),
            icon: PlusIcon,
            variant: ButtonVariants.Dark,
            onClick: () => {
              form.handleSubmit();
            },
          },
        ]}
      >
        <Button
          label={t("add-guest")}
          onClick={() => setIsDialogOpen(true)}
          icon={PlusIcon}
          color={ButtonColors.Blue}
        />
      </Dialog>
    </>
  );
}
